import S2HalfScreenImage from './S2HalfScreenImage';

export default S2HalfScreenImage;
